import { SerializedEditorState } from "lexical"

export interface LexicalText {
  html?: string
  markdown?: string
  nodes?: SerializedEditorState
  preferred_format?: "markdown" | "html"
}

export const STARTING_NODES: SerializedEditorState = {
  root: {
    children: [
      {
        children: [],
        direction: null,
        format: "",
        indent: 0,
        type: "paragraph",
        version: 1,
      },
    ],
    direction: null,
    format: "",
    indent: 0,
    type: "root",
    version: 1,
  },
} as unknown as SerializedEditorState
